module.exports = __webpack_public_path__ + "static/img/no_verity_user.5b33b5ac.png";